import { ImageOff } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';
import Icon from '../v2/ui/Icon/Icon';

const DEFAULT_ICON_SIZE = 48;

const useStyles = makeStyles<{ size: number }>()((theme, { size }) => ({
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: theme.palette.text.disabled,
    width: size,
    height: size,
    strokeWidth: 1,
  },
}));

interface EmptyMediaIconProps {
  size?: number;
}

const EmptyMediaIcon = ({ size = DEFAULT_ICON_SIZE }: EmptyMediaIconProps) => {
  const { classes } = useStyles({ size });

  return <Icon icon={ImageOff} size="lg" className={classes.icon} />;
};

export default EmptyMediaIcon;
